export const SIP_STATUSES = {
    CONNECTED: "connected",
    DISCONNECTED: "disconnected",
    REGISTERED: "registered",
    UNREGISTERED: "unregistered",
    REGISTRATION_FAILED: "registrationFailed",
    FAILED: "failed",
    REJECTED: "rejected",
    ENDED: "ended",
    READY: "ready",
};

export const PHONE_STATES = {
    READY: "ready",
    CONVERSATION: "conversation",
    DIALING: "dialing",
    HANDING: "hanging",
    RINGING: "ringing",
};

export const LOG_TYPES = {
    HANGUP: "hangup",
    DIAL: "dial",
    CONFIRMED: "confirmed",
};

export const CALL_TYPES = {
    DEFAULT: 0,
    CUSTOM: 1,
    LOGISTIC: 2,
    INCOMING: 3
}